import * as React from 'react';
import { IChannel } from '../../../../../../data/api/models';
// tslint:disable:max-line-length

interface ITripDetailsForm {
  channel: IChannel;
  name: string;
}

class GroupType extends React.Component<ITripDetailsForm> {
  public renderIndividualIcon = () => {
    return (
      <div className="icon-container">
        <svg id="icons" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 95 95">
          <path className="cls-1"
                d="M47.5,36.76a7,7,0,1,0-7-7A7,7,0,0,0,47.5,36.76Zm3,0.48h-6a9,9,0,0,0-9,9v7.28l0,0.11,0.5,0.16a40.89,40.89,0,0,0,12.21,2c6.6,0,10.42-1.88,10.66-2l0.47-.24h0.05V46.22A9,9,0,0,0,50.48,37.24Z"/>
        </svg>
      </div>
    );
  }

  public renderCoupleIcon = () => {
    return (
      <div className="icon-container">
        <svg id="icons" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 95 95">
          <path className="cls-1"
                d="M35.88,38.06a6.16,6.16,0,1,0-6.16-6.16A6.16,6.16,0,0,0,35.88,38.06Zm2.61,0.42H33.27a7.9,7.9,0,0,0-7.89,7.89v6.4l0,0.1L25.83,53a35.94,35.94,0,0,0,10.73,1.73A22,22,0,0,0,45.93,53l0.41-.21h0v-6.4A7.9,7.9,0,0,0,38.5,38.48Z"/>
          <path className="cls-1"
                d="M59.12,38.06A6.16,6.16,0,1,0,53,31.9,6.16,6.16,0,0,0,59.12,38.06Zm2.61,0.42H56.5a7.9,7.9,0,0,0-7.89,7.89v6.4l0,0.1L49.07,53A35.94,35.94,0,0,0,59.8,54.73,22,22,0,0,0,69.17,53l0.41-.21h0v-6.4A7.9,7.9,0,0,0,61.73,38.48Z"/>
        </svg>
      </div>
    );
  }

  public renderSingleParentIcon = () => {
    return (
      <div className="icon-container icon-container--single-parent">
        <svg id="icons" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 95 95">
          <path className="cls-1"
                d="M44.2,34.75a7.14,7.14,0,1,0-7.14-7.14A7.14,7.14,0,0,0,44.2,34.75Zm3,0.49H41.17A9.15,9.15,0,0,0,32,44.37v7.41l0,0.12,0.51,0.16a41.61,41.61,0,0,0,12.42,2c6.72,0,10.61-1.91,10.85-2l0.48-.24h0.05V44.37A9.15,9.15,0,0,0,47.22,35.23Z"/>
          <path className="cls-2"
                d="M54.17,44A5.16,5.16,0,1,0,49,38.86,5.16,5.16,0,0,0,54.17,44Zm2.19,0.35H52A6.62,6.62,0,0,0,45.37,51v5.44l0.37,0.12a30.11,30.11,0,0,0,9,1.45,18.46,18.46,0,0,0,7.85-1.47l0.34-.17h0V51A6.62,6.62,0,0,0,56.36,44.37Z"/>
        </svg>
      </div>
    );
  }

  public renderFamilyIcon = () => {
    return (
      <div className="icon-selected-family">
        <svg id="icons" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 95 95">
          <path className="cls-1"
                d="M51.82,28.3A7.63,7.63,0,0,1,55.37,34,6.15,6.15,0,1,0,51.82,28.3Zm-4,12.61a6.16,6.16,0,1,0-6.16-6.16A6.16,6.16,0,0,0,47.78,40.9Zm2.61,0.42H45.17a7.89,7.89,0,0,0-7.88,7.88v6.39l0,0.1,0.44,0.14a35.9,35.9,0,0,0,10.72,1.73,22,22,0,0,0,9.36-1.76l0.41-.21h0V49.2A7.89,7.89,0,0,0,50.4,41.32ZM60.58,35H55.4a7.59,7.59,0,0,1-2.34,5.28,9.37,9.37,0,0,1,6.69,9v2A21.21,21.21,0,0,0,68,49.45l0.41-.21h0V42.85A7.89,7.89,0,0,0,60.58,35ZM37,34.55a6.12,6.12,0,0,0,3.27-1,7.62,7.62,0,0,1,2.86-4.86c0-.12,0-0.23,0-0.35A6.16,6.16,0,1,0,37,34.55Zm5.53,5.7A7.59,7.59,0,0,1,40.17,35l-0.58,0H34.37a7.89,7.89,0,0,0-7.88,7.88v6.39l0,0.1,0.44,0.14a36.93,36.93,0,0,0,8.88,1.67V49.21A9.37,9.37,0,0,1,42.51,40.25Z"/>
          <path className="cls-2"
                d="M60.92,46.18a4.45,4.45,0,1,0-4.46-4.45A4.45,4.45,0,0,0,60.92,46.18Zm1.89,0.3H59a5.71,5.71,0,0,0-5.7,5.7v4.7L53.66,57a26,26,0,0,0,7.75,1.25A15.93,15.93,0,0,0,68.19,57l0.3-.15h0V52.19A5.71,5.71,0,0,0,62.81,46.48Z"/>
        </svg>
      </div>
    );
  }

  public renderGroupChildIcon = () => {
    return (
      <div className="icon-container">
      <svg version="1.1" id="icons" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 95 95">
        <path className="cls-1" d="M47.5,42.1c2.8,0,5-2.2,5-5s-2.2-5-5-5s-5,2.2-5,5C42.4,39.9,44.7,42.1,47.5,42.1z M49.6,42.4h-4.3
          c-3.6,0-6.5,2.9-6.5,6.5v5.3v0.1l0.4,0.1c2.8,0.9,5.8,1.4,8.8,1.4c4.8,0,7.5-1.4,7.7-1.4l0.4-0.1l0,0v-5.3
          C56.1,45.3,53.2,42.5,49.6,42.4L49.6,42.4z"/>
      </svg>
      </div>
    );
  }

  public render() {
    const { name } = this.props;
    let render;
    switch (name) {
      case 'individual':
        render = this.renderIndividualIcon();
        break;
      case 'couple':
        render = this.renderCoupleIcon();
        break;
      case 'single_parent_family':
        render = this.renderSingleParentIcon();
        break;
      case 'family':
        render = this.renderFamilyIcon();
        break;
      case 'independent_child':
        render = this.renderGroupChildIcon();
        break;
    }
    return(
      <div className="svg-icon">
        {render}
      </div>
    );
  }
}

export default GroupType;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/scenes/TripDetails/components/GroupType/GroupType.tsx